import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  Overlay,
  Menu,
  MenuHeader,
  MenuTitle,
  MenuClose,
  MenuNav,
  NavItem,
  Badge,
  UserSection,
  UserInfo,
  UserDetails,
  UserName,
  UserEmail,
  AdminSection,
  AdminItem,
  LogoutButton,
} from './MobileMenu.style';

const MobileMenu = ({
  isOpen,
  onClose,
  navItems,
  isActive,
  onNavigate,
  cartCount,
  displayName,
  email,
  isAdmin,
  adminItems,
  onChangeDepartment,
  onLogout,
}) => {
  const { t } = useTranslation();

  // Prevent body scroll when open
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const handleNavigate = (path) => {
    onNavigate(path);
    onClose();
  };

  const handleChangeDepartment = () => {
    onChangeDepartment();
    onClose();
  };

  const handleLogout = () => {
    onClose();
    onLogout?.();
  };

  return (
    <>
      <Overlay $isOpen={isOpen} onClick={onClose} />
      <Menu $isOpen={isOpen}>
        <MenuHeader>
          <MenuTitle>Menu</MenuTitle>
          <MenuClose onClick={onClose} aria-label={t('close')}>
            <i className="mdi mdi-close" />
          </MenuClose>
        </MenuHeader>

        <MenuNav>
          {navItems.map((item) => (
            <NavItem
              key={item.path}
              $active={isActive(item.path)}
              onClick={() => handleNavigate(item.path)}
            >
              <i className={`mdi ${item.icon}`} />
              {item.label}
              {item.badge && cartCount > 0 && <Badge>{cartCount}</Badge>}
            </NavItem>
          ))}
        </MenuNav>

        <UserSection>
          <UserInfo>
            <i className="mdi mdi-account-circle" />
            <UserDetails>
              <UserName>{displayName}</UserName>
              {email && <UserEmail>{email}</UserEmail>}
            </UserDetails>
          </UserInfo>
        </UserSection>

        {isAdmin && (
          <AdminSection>
            {adminItems.map((item) => (
              <AdminItem key={item.path} onClick={() => handleNavigate(item.path)}>
                <i className={`mdi ${item.icon}`} />
                {item.label}
              </AdminItem>
            ))}
            <AdminItem onClick={handleChangeDepartment}>
              <i className="mdi mdi-swap-horizontal" />
              {t('changeDepartment')}
            </AdminItem>
          </AdminSection>
        )}

        <LogoutButton onClick={handleLogout}>
          <i className="mdi mdi-logout" />
          {t('logout')}
        </LogoutButton>
      </Menu>
    </>
  );
};

MobileMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      badge: PropTypes.bool,
    })
  ).isRequired,
  isActive: PropTypes.func.isRequired,
  onNavigate: PropTypes.func.isRequired,
  cartCount: PropTypes.number,
  displayName: PropTypes.string.isRequired,
  email: PropTypes.string,
  isAdmin: PropTypes.bool,
  adminItems: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  onChangeDepartment: PropTypes.func.isRequired,
  onLogout: PropTypes.func,
};

export default MobileMenu;
